const getMediaDownloadPath = require("./getMediaDownloadPath");
const extractLinkData = require("./extractLinkData");

module.exports = function findImageHref(attributes, media_rel, file_data, sitemap) {
	let href;
	if (attributes && attributes.field_to) {
		const link =
			attributes && attributes.field_to
				? extractLinkData(attributes.field_to, sitemap)
				: null;
		if (link && link.to) {
			href = link.to;
		}
	} else if (
		media_rel.type.includes("image") &&
		file_data &&
		file_data.attributes &&
		file_data.attributes.uri &&
		file_data.attributes.uri.url
	) {
		href = `${process.env.GATSBY_BACKEND_URL}${file_data.attributes.uri.url}`;
	}
	return href;
};
